import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getExperienceBasicInfo } from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { selectedVariations } from "@src/store/slices/variations";
import { mpVisualBuilderControlGroupUnlocked } from "@src/utils/mixpanel";

export const trackControlGroupUnlocked = createAsyncThunk<void, void>(
  "experienceBuilder/tracking/controlGroupUnlocked",
  (_, { getState }) => {
    const experienceInfo = getExperienceBasicInfo(getState());
    if (!experienceInfo) return;

    const { experienceId, experienceName, experienceType } = experienceInfo;
    const variations = selectedVariations(getState());
    const device = experienceBuilderSlice.selectors.getDevice(getState());

    mpVisualBuilderControlGroupUnlocked({
      experienceId,
      experienceName,
      experienceType,
      testGroupCount: variations.length,
      builderMode: device,
    });
  }
);
